import { useEffect, useRef, useState } from "react";
import "./select.css";
import { Icon } from "../icon";
import type { IconName } from "../icon/IconName";
import { Button } from "../button";

export type SelectItem = {
  label: string;
  iconName?: IconName;
  onClick: () => void;
};

interface SelectProps {
  className?: string;
  label?: string;
  iconName?: IconName;
  items: SelectItem[];
  withButton?: boolean;
}

export default function Select({
  className,
  label,
  iconName = "chevron-down",
  items,
  withButton = false,
}: SelectProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={`select ${className ? className : "select"}`} ref={ref}>
      {withButton ? 
       <Button label={"Ajouter un nouvel utilisateur"} rightIcon="chevron-down" onClick={() => setOpen((prev) => !prev)}/> :
       <button
          type="button"
          className="select-trigger"
          onClick={() => setOpen((prev) => !prev)}
        >
        {label && <div>{label}</div>}
        <Icon name={iconName} size="small"></Icon>
      </button> }
      {open && (
        <div className="select-dropdown">
          {items.map((item) => (
            <button
              key={item.label}
              type="button"
              className="select-item"
              onClick={() => {
                item.onClick();
                setOpen(false);
              }}
            >
              {item.iconName && 
                <Icon 
                  className={`${item.iconName == "delete" ? "select-item-icon-delete" : "select-item-icon"}`} 
                  name={item.iconName}>
                </Icon>}
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}